import React, { Component } from 'react'
import {RTLTable, RTLCol, RTLButton} from '../RTLKit';
import {Statistic, Card, Row, Icon, Input,Button } from 'antd';
import moment from 'jalali-moment'
import { Link } from 'react-router-dom';


export default class DashboardPage extends Component {
    constructor(props) {
      super(props);
      this.props.getNote();
      this.state = {
          value: moment(),
        //   note: this.props.getNoteValues?this.props.getNoteValues:''
        note: ''

      }
    }

    componentDidMount () {
        this.props.getItem()
        // this.props.getNote()
    }

    componentWillReceiveProps(nextProps) {
        // if (this.props.getNoteValues != nextProps.getNoteValues) {
        //     this.setState({note:this.props.getNoteValues})
        // }
        this.setState({note:this.props.getNoteValues})
        // if(this.props.getNoteValues==this.state.note){

        // }
    }

    onChange (note) {
        this.setState({note:note})
    }

    async setNote () {
        await this.props.handleSubmit(this.state.note);
        await window.location.reload();
    }

    render () {
        const { list } = this.props;
        const { TextArea } = Input;
        return (
            <div>
                <Row gutter={[16,16]}>
                    <RTLCol md={8} sm={24}>
                        <RTLCol md={24}>
                            <Card>
                                <RTLCol md={8}>
                                    <Icon type="check-circle" className="dashboardIcon purpleIcon" />
                                </RTLCol>
                                <RTLCol md={16}>
                                    <Statistic
                                        title="تعداد سفارشات تکمیل شده"
                                        // value={28}
                                        value={this.props.initialValues ? this.props.initialValues.completed : 0}
                                    />
                                </RTLCol>
                            </Card>
                        </RTLCol>
                    </RTLCol>
                    <RTLCol md={8} sm={24}>
                        <RTLCol md={24}>
                            <Card>
                                <RTLCol md={8}>
                                    <Icon type="clock-circle" className="dashboardIcon blueIcon" />
                                </RTLCol>
                                <RTLCol md={16}>
                                    <Statistic
                                        title="تعداد سفارشات ارجاع داده شده"
                                        // value={58}
                                        value={this.props.initialValues ? this.props.initialValues.assigned : 0}
                                    />
                                </RTLCol>
                            </Card>
                        </RTLCol>
                    </RTLCol>
                    <RTLCol md={8} sm={24}>
                        <RTLCol md={24}>
                            <Card>
                                <RTLCol md={8}>
                                    <Icon type="plus-circle" className="dashboardIcon greenIcon" />
                                </RTLCol>
                                <RTLCol md={16}>
                                    <Statistic
                                        title="تعداد سفارشات ایجاد شده"
                                        // value={128}
                                        value={this.props.initialValues ? this.props.initialValues.created : 0}
                                    />
                                </RTLCol>
                            </Card>
                        </RTLCol>
                    </RTLCol>
                </Row>
                <Row gutter={[16,16]}>
                    <RTLCol sm={24}>
                        <RTLCol md={16} sm={24}>
                            <Row gutter={[16,16]} className="shortcutBoxWrapper">
                                <RTLCol md={8} sm={24}>
                                    <div className="shortcutBox blueBox" >
                                        <Link to="/order/list">
                                            <div><Icon type="copy" /></div>
                                            <div>لیست درخواست ها</div>
                                        </Link>
                                    </div>
                                </RTLCol>

                                <RTLCol md={8} sm={24} >
                                    <div className="shortcutBox yellowBox">
                                        <Link to="/transaction/list">
                                            <div><Icon type="transaction" /></div>
                                            <div>لیست تراکنش ها</div>
                                        </Link>
                                    </div>
                                </RTLCol>
                                <RTLCol md={8} sm={24} >
                                    <div className="shortcutBox redBox">
                                        <Link to="/product/list">
                                            <div><Icon type="shopping" /></div>
                                            <div>لیست محصولات</div>
                                        </Link>
                                    </div>
                                </RTLCol>
                            </Row>
                            <Row gutter={[16,16]} className="shortcutBoxWrapper">
                                <RTLCol md={8} sm={24}>
                                    <div className="shortcutBox grayBox" >
                                        <Link to="/user/list">
                                            <div><Icon type="user" /></div>
                                            <div>لیست کاربران</div>
                                        </Link>
                                    </div>
                                </RTLCol>

                                <RTLCol md={8} sm={24} >
                                    <div className="shortcutBox greenBox">
                                        <Link to="/user/add">
                                            <div><Icon type="user-add" /></div>
                                            <div>ایجاد کاربر</div>
                                        </Link>
                                    </div>
                                </RTLCol>
                                <RTLCol md={8} sm={24} >
                                    <div className="shortcutBox lightBlueBox">
                                        <Link to="/product-category/list">
                                            <div><Icon type="cluster" /></div>
                                            <div>لیست دسته بندی محصولات</div>
                                        </Link>
                                    </div>
                                </RTLCol>
                            </Row>
                        </RTLCol>
                        <RTLCol md={8} sm={24}>
                            <Row type="flex" justify="end" align="middle">
                                <RTLCol md={24} sm={24} type="flex" justify="start" align="middle" >
                                    <div className="note-wrapper">
                                        <div className="note-title">یادداشت ها</div>
                                        <div className="note-text">
                                            <TextArea
                                                name="note"
                                                rows="20"
                                                placeholder="یادداشت"
                                                className="sticky-note"
                                                onChange={(event) => this.setState({note:event.target.value})}
                                                value={this.state.note ? this.state.note : ''}
                                                // defaultValue={this.props.getNoteValues ? this.props.getNoteValues : ''}
                                            />
                                        </div>
                                    </div>
                                    <Button onClick={(event) => this.setNote()} style={{ width: '97%' }}>ذخیره تغییرات یادداشت</Button>
                                </RTLCol>
                            </Row>
                        </RTLCol>
                    </RTLCol>
                </Row>
            </div>
        );
    }
}
